<template>
  <div>
    <b-breadcrumb :items="items" />
    <h3>{{ printer.description }}</h3>

    <b-form inline class="mt-5">
      <label class="sr-only" for="printerDescription">Description</label>
      <b-form-select
        class="mb-2 mr-sm-2 mb-sm-0"
        v-model="printer.ticket_type"
        :options="ticket_types"
      />
      <b-button :disabled="saving" variant="primary" @click="updatePrinter"
        >Save</b-button
      >
    </b-form>

    <p><b-btn v-b-modal.createDimension>Create Dimension</b-btn></p>
    <b-modal
      id="createDimension"
      title="Create Dimension"
      @ok="createDimension"
    >
      <b-input
        placeholder="Width"
        v-model="dimension.width"
        type="number"
      ></b-input>
      <b-input
        placeholder="Height"
        v-model="dimension.height"
        type="number"
      ></b-input>
    </b-modal>
    <b-table striped hover :fields="fields" :items="dimensions">
      <template slot="actions" slot-scope="cell">
        <b-button-group>
          <click-confirm>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click.stop="removeDimension(cell.item.id)"
            >
              <icon name="remove" class="align-middle"></icon>
            </b-button>
          </click-confirm>
        </b-button-group>
      </template>
    </b-table>
  </div>
</template>

<script>
import PrintersApi from "@/printers_api";
import Notify from "@/notify";
import ClickConfirm from "click-confirm";

export default {
  components: {
    "click-confirm": ClickConfirm,
  },
  computed: {
    items() {
      return [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Server",
          to: {
            name: "EditPrintServer",
            params: { id: this.printer.print_server_id },
          },
        },
        {
          text: "Printer",
          active: true,
        },
      ];
    },
  },
  mixins: [Notify],
  watch: {
    $route(to) {
      this.loadItem(to.params.id);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadItem(to.params.id);
    });
  },
  data() {
    return {
      printer: {
        id: 0,
        description: "",
        ticket_type: "label",
        print_server_id: 0,
      },
      ticket_types: [
        { value: "label", text: "Label" },
        { value: "receipt", text: "Receipt" },
      ],
      dimensions: [],
      dimension: {
        width: null,
        height: null,
      },
      saving: false,
      fields: ["height", "width", "actions"],
    };
  },
  methods: {
    async loadItem(id) {
      if (!Number.isInteger(parseInt(id, 0))) {
        return;
      }
      try {
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).retrievePrinter(id);
        this.printer = response.data;
        this.loadDimensions(id);
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async loadDimensions(id) {
      try {
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).retrievePrinterDimensions(id);
        this.dimensions = response.data;
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async removeDimension(id) {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).deleteDimension(id);
        await this.loadDimensions(this.printer.id);
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async createDimension() {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).createDimension(
          this.printer.id,
          this.dimension
        );
        this.loadDimensions(this.printer.id);
        this.dimension = { width: null, height: null };
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async updatePrinter() {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).updatePrinter(
          this.printer.id,
          this.printer
        );
        this.loadItem(this.printer.id);
      } catch (e) {
        this.notifyError(e.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/printers/PrinterEdit.vue